// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__SJet7","header":"Banner_header__JfdeX","content":"Banner_content__6BgmB"};